import { assign, get, isEmpty, find, filter } from "lodash";
import popup from "~/views/Popup/popup";

export const getFeaturedEpisode = show => {
	let featuredEpisode;
	show.seasons.forEach((season, n) => {
		season.episodes.forEach((episode, i) => {
			if (
				episode.gist.watchHistory &&
				episode.gist.watchHistory.latestEpisode
			) {
				//If episode watched, get next episode
				if (episode.gist.watchHistory.watchedPercentage > 90) {
					featuredEpisode = getNextEpisode(show, n, i);
				}
				//Current episode
				else {
					featuredEpisode = episode;
				}
			}
		});
	});

	//If no watch history, get first episode
	if (featuredEpisode == null && show.seasons[0]) {
		for (let episode of show.seasons[0].episodes) {
			if (episode.gist.episodeNumber !== undefined) {
				featuredEpisode = episode;
				break;
			}
		}
	}

	return featuredEpisode;
};

export const getNextEpisode = (show, seasonIndex, episodeIndex) => {
	const season = show.seasons[seasonIndex];

	let nextEpisode;

	//In the season
	if (season.episodes[episodeIndex + 1]) {
		nextEpisode = season.episodes[episodeIndex + 1];
	}

	//In the series
	else if (
		show.seasons[seasonIndex + 1] &&
		show.seasons[seasonIndex + 1].episodes[0]
	) {
		nextEpisode = show.seasons[seasonIndex + 1].episodes[0];
	}

	//Or the first episode
	else {
		nextEpisode = show.seasons[0].episodes[0];
	}

	return nextEpisode;
};

export const getFilmSrc = (
	videoInfo,
	seasons,
	seasonIdx,
	episodeIdx,
	fileType = ""
) => {
	if (!videoInfo) return;
	const customControls = {
		volumePanel: { inline: false },
		children: [
			"playToggle",
			"progressControl",
			"currentTimeDisplay",
			"timeDivider",
			"durationDisplay",
			"volumePanel",
			"fullscreenToggle"
		]
	};
	
	const watchedTime = videoInfo.watchHistory ? videoInfo.watchHistory.watchedTime : 0;
	const customSkin = "./newsSkin";

	const video = {
		...videoInfo,
		fileType: fileType,
		watchedTime: watchedTime,
	};
	popup.newsEpisodeOverlay({
		video,
		customSkin,
		customControls,
		seasons,
		seasonIdx,
		episodeIdx
	});
};

export function getSeasonData(showData) {
	const seasonData = {};
	if (!isEmpty(showData) && showData.seasons) {
		showData.seasons.forEach((elm, idx) => {
			seasonData[elm.title.toLowerCase()] = elm.episodes;
		})
	}
	return seasonData;
}

export function parseSeasonNames(showData) {
	return showData.map(e => e.title);
}

export function getThumbnailImage(gist) {
	let w = 400;
	let url =
		gist.videoImageUrl ||
		get(gist.videoImage, "url") ||
		get(gist, "landscapeImageUrl") ||
		get(gist.images, "_16x9Image.secureUrl") ||
		get(gist, 'imageGist["_16x9"]') ||
		get(gist.images, "_16x9.url") ||
		get(window.settings, "images.placeholderCover");
	return `${url}?impolicy=resize&w=${w}&h=${w * 0.5625}`;
}

export function getLowQualityImage(gist) {
	let url =
		gist.videoImageUrl ||
		get(gist.videoImage, "url") ||
		get(gist, "landscapeImageUrl") ||
		get(gist.images, "_16x9Image.secureUrl") ||
		get(gist, 'imageGist["_16x9"]') ||
		get(gist.images, "_16x9.url") ||
		get(window.settings, "images.placeholderCover");
	return `${url}?impolicy=resize&w=20&h=20`;
}

export function parseShowData(showData) {
	let parsedShowData = showData;
	let sortedSeasons = [];
	let extrasIdx = -1;
	parsedShowData.seasons.forEach((season, idx) => {
		if (season.title.toLowerCase() !== 'extras') {
			sortedSeasons.push(season);
		} else {
			extrasIdx = idx;
		}
	})

	// sortedSeasons.sort((a, b) => {
	// 	let titleA = a.title.toLowerCase();
	// 	let titleB = b.title.toLowerCase();

	// 	if (titleA < titleB) return 1;
	// 	if (titleA > titleB) return -1;
	// 	return 0;
	// })

	if (extrasIdx > -1) {
		sortedSeasons.push(parsedShowData.seasons[extrasIdx]);
	}
	parsedShowData.seasons = sortedSeasons;
	return parsedShowData;
}

export function removeLiveAndTrailer(items) {
	if (items) {
		return items.filter(e => e.gist && !e.gist.isLiveStream && !e.gist.isTrailer);
	}
	return [];
}

export function getInitialSeason(seasons) {
	const urlParams = new URLSearchParams(window.location.search);
	const isExtra = urlParams.get('extra');
	let initialSeason = 0;
	if (seasons.length > 0 && isExtra) initialSeason = seasons.length - 1;
	return initialSeason;
}

export const getCurrentItems = (showData, currentSeasonID, currentEpisodeID, currentType) => {
    const seasons = showData.seasons;
    const curSeasonData = seasons[currentSeasonID];
    const curEpisodes = curSeasonData.episodes;
    const curSegments = curEpisodes[currentEpisodeID].relatedVideos;
    if(currentType === 'episode' || currentType === 'initial'){
        return curEpisodes;
    } else if(currentType === 'segment'){
        return curSegments;
    }
    return seasons.map(season => season.title);
}

export const getActiveStyle = (currentType, type) => {
	const activeColor = window.settings.brand.cta ? window.settings.brand.cta.primary.textColor : '';
	const activeStyle = {color: activeColor};
	if(currentType === 'initial' && type === 'episode'){
		return activeStyle;
	}
	return type === currentType  ? activeStyle : {};
}

export const getSeriesData = (showData) => {
	return [{
		gist: {
			permalink: showData.gist.permalink
		}
	}]
}

export function formatNewsDuration(runtime){
    let res = '';
    let mins = ~~(runtime / 60);

    if(mins === 0){
        res = `${runtime} SEC`
    } else {
        res = `${mins} MIN`
    }

    return res;
}

export function removePromos(items){
	return filter(items, function(item){return !(item.tags.length > 0 && find(item.tags, {'title': 'promo'}))})
}

export function getMobileSizeImage(url){
	const imageWidth = window.innerWidth;
	const imageHeight = imageWidth / 16 * 9;
	return `${url}?impolicy=resize&w=${imageWidth}&h=${imageHeight}`
}